<template>
  <main class="grid min-h-dvh place-items-center bg-background p-6">
    <Card class="w-full max-w-sm">
      <CardHeader>
        <CardTitle>{{ $t('common.authorization') }}</CardTitle>
      </CardHeader>
      <CardContent>
        <form class="grid gap-4" @submit.prevent="submit">
          <div class="grid gap-2">
            <Label for="auth-email">{{ $t('auth.email') }}</Label>
            <Input id="auth-email" v-model="email" autocomplete="email" name="email" aria-label="Email" />
          </div>
          <div class="grid gap-2">
            <Label for="auth-password">{{ $t('auth.password') }}</Label>
            <Input
              id="auth-password"
              v-model="password"
              type="password"
              autocomplete="current-password"
              name="password"
              aria-label="Password" />
          </div>
          <p
            v-if="error"
            role="alert"
            class="rounded-md border border-destructive/50 bg-destructive/10 p-3 text-sm text-destructive">
            {{ error }}
          </p>
          <Button type="submit" class="w-full" :disabled="isSubmitting">
            {{ $t('auth.signInPassword') }}
          </Button>
        </form>
        <div class="my-4 flex items-center gap-3 text-sm text-muted-foreground">
          <span class="h-px flex-1 bg-border" />
          <span>{{ $t('auth.or') }}</span>
          <span class="h-px flex-1 bg-border" />
        </div>
        <Button type="button" variant="outline" class="w-full" @click="signInWithGoogle">
          {{ $t('common.signInGoogle') }}
        </Button>
      </CardContent>
    </Card>
  </main>
</template>

<script setup lang="ts">
import {ref} from 'vue'
import {Button} from '@/components/ui/button'
import {Card, CardContent, CardHeader, CardTitle} from '@/components/ui/card'
import {Input} from '@/components/ui/input'
import {Label} from '@/components/ui/label'
import {useUserStore} from '@/stores/user'

const userStore = useUserStore()
const baseUrl = import.meta.env.VITE_BASE_URL
const email = ref('')
const password = ref('')
const error = ref('')
const isSubmitting = ref(false)

async function submit() {
  if (isSubmitting.value) return
  isSubmitting.value = true
  error.value = ''
  try {
    await userStore.signInWithPassword(email.value, password.value)
  } catch {
    error.value = 'Invalid email or password'
  } finally {
    isSubmitting.value = false
  }
}

function signInWithGoogle() {
  window.location.href = `${baseUrl}/api/auth/google`
}
</script>
